import { ORDER_STATUS } from '@bagonboard/wiseman';

import { fetchGet, fetchPut } from '../../providers/Fetch';
import { agentsFetch } from '../Agents/actions';
import {
  SERVICE_ERROR, SERVICE_REQUEST, SERVICE_STATUS_UPDATE, SERVICE_SUCCESS, SERVICE_UPDATE,
} from './types';

const { OPEN, AWAITING } = ORDER_STATUS;

const serviceError = error => ({
  type: SERVICE_ERROR,
  error,
});

const serviceRequest = {
  type: SERVICE_REQUEST,
};

const serviceSuccess = data => ({
  type: SERVICE_SUCCESS,
  data,
});

const serviceUpdate = data => ({
  type: SERVICE_UPDATE,
  data,
});

const serviceStatusUpdate = data => ({
  type: SERVICE_STATUS_UPDATE,
  data,
});

export const serviceFetch = id => async (dispatch) => {
  dispatch(serviceRequest);
  try {
    const result = await fetchGet(`/order/service/${id}`);

    if (result.areas && result.areas.length > 0) {
      await dispatch(agentsFetch([result.areas[0]]));
    }

    dispatch(serviceSuccess(result));
  } catch (e) {
    dispatch(serviceError(e.message));
  }
};

export const assignAgentToService = ({ serviceId, agentId }) => async (dispatch, getState) => {
  dispatch(serviceRequest);
  try {
    const {
      service: {
        data: { order: { status } },
      },
    } = getState();
    if ([OPEN, AWAITING].includes(status)) {
      dispatch(serviceError("Can't assign a driver to an unconfirmed order"));
    } else {
      const result = await fetchPut('order/service/agent', { serviceId, agentId });
      dispatch(serviceStatusUpdate(result));
    }
  } catch (e) {
    dispatch(serviceError(e.message));
  }
};

export const updateServiceStatus = ({ serviceId, status }) => async (dispatch) => {
  dispatch(serviceRequest);
  try {
    const result = await fetchPut('order/service/status', { serviceId, status });
    dispatch(serviceStatusUpdate(result));
  } catch (e) {
    dispatch(serviceError(e.message));
  }
};

export const updateService = ({ serviceId, ...rest }) => async (dispatch) => {
  dispatch(serviceRequest);
  try {
    const result = await fetchPut('order/service', { _id: serviceId, ...rest });
    dispatch(serviceUpdate(result));
  } catch (e) {
    dispatch(serviceError(e.message));
  }
};
